// extracted by mini-css-extract-plugin
export default {"container":"cp8q2ll4w"};